import Vue from 'vue'
import Vuex from 'vuex'
import {getTokenCookie, removeTokenCookie, setTokenCookieByMinutes} from '@/utils/cookie'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 初始化时从Cookie读取Token（内存中维护响应式状态）
        token: getTokenCookie() || ''
    },
    mutations: {
        // 设置Token（同步）：更新内存+Cookie
        SET_TOKEN(state, token) {
            state.token = token
            setTokenCookieByMinutes(token) // 存入Cookie
        },
        // 清除Token（同步）：清空内存+Cookie
        REMOVE_TOKEN(state) {
            state.token = ''
            removeTokenCookie() // 清除Cookie
        }
    },
    actions: {
        // 登录成功设置Token
        setToken({ commit }, token) {
            commit('SET_TOKEN', token)
        },
        // 退出登录清除Token
        logout({ commit }) {
            commit('REMOVE_TOKEN')
        }
    },
    getters: {
        // 判断是否登录
        isLogin: state => !!state.token
    }
})